























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getCategoryList } from '@/api/prize'
import { listDrawPrize } from '@/api/drawPrize'
import Empty from '@/components/Empty/index.vue'

@Component({
  name: 'AddPrize',
  components: {
    Empty
  }
})
export default class extends Vue {
  @Prop({ default: [] }) private checkList!: any[]
  
  private prizeCategories: any[] = []
  private allPrizes: any[] = []
  private selectedPrizes: any[] = []
  private searchValue: string = ''
  private selectedCategory: number | null = null
  private statusFilter: number = -1
  private currentPage: number = 1
  private pageSize: number = 20
  private totalItems: number = 0
  
  get filteredPrizeList() {
    let result = [...this.allPrizes];
    
    // 应用状态过滤
    if (this.statusFilter !== -1) {
      result = result.filter(item => item.status === this.statusFilter);
    }
    
    // 应用搜索过滤
    if (this.searchValue.trim()) {
      const keyword = this.searchValue.toLowerCase();
      result = result.filter(item => 
        item.name.toLowerCase().includes(keyword) || 
        (item.prizeName && item.prizeName.toLowerCase().includes(keyword))
      );
    }
    
    // 更新总数
    this.totalItems = result.length;
    
    // 分页
    const start = (this.currentPage - 1) * this.pageSize;
    return result.slice(start, start + this.pageSize);
  }

  // 格式化价格显示
  private formatPrice(price: any): string {
    if (!price) return '0.00'
    const numPrice = Number(price)
    return numPrice.toFixed(2)
  }
  
  created() {
    this.init();
    
    // 如果已有选中的奖品，先标记这些奖品
    if (this.checkList && this.checkList.length > 0) {
      this.selectedPrizes = [...this.checkList];
    }
  }
  
  async init() {
    // 加载所有奖品
    await this.loadAllPrizes();
    
    // 预选中已有的奖品
    this.$nextTick(() => {
      this.preSelectPrizes();
    });
  }
  
  async loadAllPrizes() {
    try {
      // 使用正确的API方法获取所有奖品
      const res = await listDrawPrize();
      if (res && res.data && res.data.code === 1) {
        this.allPrizes = (res.data.data || []).map((item: any) => ({
          ...item,
          prizeId: item.id,
          prizeName: item.name,
          amount: this.getPrizeAmount(item.id) || 1
        }));
        console.log('获取到奖品列表:', this.allPrizes);
      } else {
        console.warn('获取奖品列表失败:', res);
        this.$message.error('获取奖品列表失败');
      }
    } catch (error) {
      console.error('加载奖品列表失败', error);
      this.$message.error('加载奖品列表失败');
    }
  }
  
  // 获取已选奖品的数量
  getPrizeAmount(id: number) {
    const existingPrize = this.checkList.find((item: any) => 
      item.prizeId === id || item.id === id);
    return existingPrize ? existingPrize.amount : 1;
  }
  
  // 预选中已有的奖品
  preSelectPrizes() {
    const table: any = this.$refs.prizeTable;
    if (table && this.checkList.length > 0) {
      // 对于列表中的每个奖品，检查是否在已选列表中
      this.allPrizes.forEach(prize => {
        const existingPrize = this.checkList.find((item: any) => 
          item.prizeId === prize.id || item.id === prize.id);
        
        if (existingPrize) {
          table.toggleRowSelection(prize, true);
          // 确保显示正确的数量
          prize.amount = existingPrize.amount || 1;
        }
      });
    }
  }
  
  handleSearch() {
    this.currentPage = 1;
  }
  
  handleSelectionChange(selection: any[]) {
    this.selectedPrizes = selection.map(item => ({
      ...item,
      amount: item.amount || 1
    }));
  }
  
  handleSizeChange(size: number) {
    this.pageSize = size;
  }
  
  handleCurrentChange(page: number) {
    this.currentPage = page;
  }
  
  confirmSelection() {
    // 确保每个奖品都有数量字段
    const result = this.selectedPrizes.map(prize => ({
      ...prize,
      amount: prize.amount || 1
    }));
    
    this.$emit('checkList', result);
    this.$emit('confirm');
  }
  
  cancelSelection() {
    this.$emit('cancel');
  }
}
